import { BASE_LAYOUT_RERENDER } from '@Constants/types';

const initialState = {
    overflowy: 'auto'
};

export default function baseReducer(state = initialState, action) {
    switch (action.type) {
        case BASE_LAYOUT_RERENDER:
            return {
                ...state,
                overflowy: action.payload
            };
        default:
            return state;
    }
}
